import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { useTracking } from '../../hooks/useTracking'
import DetailCard from '../common/detail-card'
import theme from '../../theme'

type Props = {}

const Content = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  font-weight: 100;
  font-size: 16px;
  line-height: 21px;
  color: ${theme.midnight800};
`
const StyledValue = styled.div`
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: ${theme.midnight800};
`
const StyledNote = styled.div`
  color: ${theme.slate500};
  font-size: 10px;
  line-height: 21px;
`

/**
 * The code the recipient types on the robot's screen. Comes from
 * `robotDelivery.accessCode`, which ex-core-api only sends on the
 * phone-authenticated tracking path and nulls once the leg is over — so the
 * card's presence needs no state check of its own. Shown by us rather than by
 * the widget (`showCode` stays off) so it survives a blocked or expired iframe.
 */
function RobotAccessCode(_props: Props, ref: React.Ref<HTMLDivElement>) {
  const { orderDetails } = useTracking()
  const accessCode = orderDetails?.robotDelivery?.accessCode

  if (!accessCode) {
    return null
  }

  return (
    <DetailCard
      ref={ref}
      title={'🔑 Robot access code'}
      data-testid="robot-access-code"
    >
      <Content>
        <StyledValue>{accessCode}</StyledValue>
        <StyledNote>
          Enter this code on the robot's screen to open the compartment
        </StyledNote>
      </Content>
    </DetailCard>
  )
}
export default forwardRef(RobotAccessCode)
